export class PlantSearchBeanModel {
    public pdesc: string;
    public reg:   string;

    [x: string]: any;
}